// Components
import { DetailedIconPiggybank } from '@zillow/constellation';
import { Box, Button, TextButton } from '@zillow/constellation-10';

import InlineStyledText from '../InlineStyledText';

import {
  StyledSecondaryButtonHideShowContainer,
  StyledSecondaryTextButtonHideShowContainer,
} from '../../../../StyledComponents/StyledComponents';

import { StyledEmptyIconContainer, StyledEmptyStateContainer } from '../../../../StyledComponents';
import { EmptyStateBodyText, EmptyStateTitleText, StyledEmptySimpleCard } from '../../../../styles';

type StyledText = {
  text: string;
  url?: string;
  styling?: string;
};

type Props = {
  title: string;
  description: string;
  ctaLink: {
    text: string;
    url: string;
  };
  ctaPrimaryButton: {
    text: string;
    url: string;
  };
  disclaimer?: Array<StyledText>;
};

const EmptyPaymentsCard = ({ title, description, ctaLink, ctaPrimaryButton, disclaimer }: Props) => {
  const getDisclaimerText = (styledTextList: Array<StyledText>) =>
    styledTextList.map((styledText) => ({
      styling: 'legal',
      ...styledText,
    }));

  const getSecondaryCTAShowHide = () => {
    return (
      <>
        <StyledSecondaryButtonHideShowContainer>
          <Button
            asChild
            data-testid="empty-payments-card-default-button"
            tone="brand"
            emphasis="outlined"
            css={{ marginLeft: '200' }}
          >
            <a href={ctaLink.url}>{ctaLink.text}</a>
          </Button>
        </StyledSecondaryButtonHideShowContainer>

        <StyledSecondaryTextButtonHideShowContainer>
          <TextButton css={{ paddingTop: '200' }} asChild data-testid="empty-leases-card-default-anchor">
            <a href={ctaLink.url}>{ctaLink.text}</a>
          </TextButton>
        </StyledSecondaryTextButtonHideShowContainer>
      </>
    );
  };

  return (
    <StyledEmptySimpleCard
      isDisabled={true}
      css={{ padding: '{spacing.1000} {spacing.600}' }}
      data-testid="empty-payments-card"
    >
      <StyledEmptyStateContainer>
        <StyledEmptyIconContainer>
          <DetailedIconPiggybank />
        </StyledEmptyIconContainer>

        <EmptyStateTitleText asChild>
          <h4>{title}</h4>
        </EmptyStateTitleText>

        <EmptyStateBodyText asChild css={{ textAlign: 'center' }}>
          <p>{description}</p>
        </EmptyStateBodyText>

        <Box
          css={{
            display: 'flex',
            flexDirection: { base: 'column', lg: 'row' },
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Button asChild tone="brand" emphasis="filled">
            <a href={ctaPrimaryButton.url}>{ctaPrimaryButton.text}</a>
          </Button>

          {ctaLink.text && ctaLink.url && getSecondaryCTAShowHide()}
        </Box>

        {disclaimer && (
          <>
            <Box css={{ marginBottom: '600' }} />
            <InlineStyledText styledTextList={getDisclaimerText(disclaimer)} />
          </>
        )}
      </StyledEmptyStateContainer>
    </StyledEmptySimpleCard>
  );
};

export default EmptyPaymentsCard;
